import {Component, OnInit} from '@angular/core';
import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/platform-browser';
import {UserService} from '../services/user.service';
import {DeviceService} from '../services/device.service';
import {Message, SelectItem, MenuItem} from 'primeng/primeng';
import {PositionService} from '../services/position.service';
import {GeofenceService} from '../services/geofence.service';
import {InterestPointService} from '../services/interest-point.service';
import {DriverService} from '../services/driver.service';
import {CommandService} from '../services/command.service';
import {WebsocketService} from '../services/websocket.service';
import * as $ from 'jquery';
import {environment} from '../../environments/environment';

declare var MarkerClusterer: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    blockedDocument: boolean = false;
    //devices : any [];
    msgs: Message[] = [];
    options: any;
    //overlays: any[];
    overlaysInterestPoints: any[] = [];

    //timerId:any;
    //deviceSelected: any;
    //positions: any [];
    //position: any;
    labels: any[];
    items: MenuItem[];
    showLegend: boolean = true;
    showGeocercas: boolean = true;
    tracking: boolean;
    showInterestPoint: boolean = true;
    showMarkerCluster: boolean = false;
    firstTime: boolean = true;
    users: SelectItem[];
    idUser: string;
    dialogShare: boolean = false;
    //markersRecorrido:google.maps.Marker[]=[];
    //polyLines:google.maps.Polyline[]=[]
    displaySendCommand: Boolean = false;
    types: SelectItem[];
    command: any;
    markerCluster;
    typeShare: String = 'A';
    urlCurrentLocation: String;
    urlRealTimeLocation: String;
    startDate: Date;
    endDate: Date;
    times: SelectItem[];
    time: number;

    constructor(
        @Inject(DOCUMENT) private document: Document, private deviceService: DeviceService
        , public userService: UserService, private positionService: PositionService
        , private geofenceService: GeofenceService, private interestPointService: InterestPointService
        , private driverService: DriverService, private commandService: CommandService, private websocketService: WebsocketService
    ) {
    }

    ngOnInit() {
        this.document.body.classList.remove('login-body');
        this.types = [
            {label: 'Desbloqueo de Motor', value: 'UNLOCKED'},
            {label: 'Bloqueo de Motor', value: 'LOCKED'},
            {label: 'Actualizar Posición', value: 'POSITION'}
        ];
        this.items = [
            {
                label: 'Update', icon: 'fa-refresh', command: () => {
                    this.init();
                }
            },
            {
                label: 'Delete', icon: 'fa-close', command: () => {
                    this.command();
                }
            },
            {label: 'Angular.io', icon: 'fa-link', url: 'http://angular.io'},
            {label: 'Theming', icon: 'fa-paint-brush', routerLink: ['/theming']}
        ];
        this.times = [
            {label: '1 Hora', value: 1},
            {label: '3 Horas', value: 3},
            {label: '6 Horas', value: 6},
            {label: '12 Horas', value: 12},
            {label: '24 Horas', value: 24},
            {label: '48 Horas', value: 48}
        ];
        this.init();
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnDestroy() {
        this.websocketService.closeConnection();
    }


    init() {
        this.command = {};
        this.options = {
            zoom: 14
        };

        //CARGA DE COMBOBOX DE USUARIOS
        this.users = [];
        this.users.push({label: this.userService.userLoged.nickName, value: this.userService.userLoged.idUser});
        this.idUser = this.userService.userLoged.idUser;
        this.userService.findUsersBranch(this.userService.userLoged.idUser).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                if (response.users) {
                    response.users.forEach(item => {
                        this.users.push({label: item.nickName, value: item.idUser});
                    });
                }
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
        });
        this.loadDevices(this.userService.userLoged.idUser);
    }

    getDriver(keyRing: String): String {
        this.driverService.findByKeyRing(keyRing).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                return response.driver.name;
            } else {
                return keyRing;
            }
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
        });
        return '';
    }

    setMap(event) {
        this.userService.map = event.map;
    }

    addMarkerInterestPoint(interestPoint: any) {
        let latLng = new google.maps.LatLng(interestPoint.latitude, interestPoint.longitude);

        let infoWindow = new google.maps.InfoWindow({
            content: this.getContentInterestPoint(interestPoint),
            maxWidth: 350
        });

        let label = {text: interestPoint.name, color: 'black', fontSize: '12px', fontWeight: 'bold'};
        let icon = {
            url: 'assets/layout/images/markers/points/' + interestPoint.type + '.png', // url
            scaledSize: new google.maps.Size(50, 50), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(25, 38), // anchor,
            labelOrigin: new google.maps.Point(interestPoint.name.length < 8 ? interestPoint.name.length * 4 : interestPoint.name.length * 2, 0)
        };

        let marker = new google.maps.Marker({position: latLng, icon: icon, label: label, zIndex: 1});
        marker.addListener('click', () => {
            infoWindow.open(this.userService.map, marker);
        });

        google.maps.event.addListener(this.userService.map, 'click', function () {
            infoWindow.close();
        });

        this.overlaysInterestPoints.push(marker);
        this.userService.overlays.push(marker);

        google.maps.event.addListener(infoWindow, 'domready', function () {
            var iwOuter = $('.gm-style-iw');
            var iwBackground = iwOuter.prev();
            iwBackground.children(':nth-child(2)').css({'display': 'none'});
            iwBackground.children(':nth-child(4)').css({'display': 'none'});
            // Moves the infowindow 115px to the right.
            //iwOuter.parent().parent().css({left: '115px'});
            //iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
            //iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
            //iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

            var iwCloseBtn = iwOuter.next();
            //iwCloseBtn.css({opacity: '1', right: '78px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
            //iwCloseBtn.css({opacity: '1', right: '30px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
            iwCloseBtn.css({'display': 'none'});

            iwCloseBtn.mouseout(function () {
                $(this).css({opacity: '1'});
            });
        });
    }

    activateTracking(idUser: String) {
        if (this.tracking === true) {
            this.websocketService.connect();
            this.websocketService.send({action: 'saveConnectionId', idUser: idUser});
        } else {
            this.websocketService.closeConnection();
        }
        localStorage.setItem('tracking', String(this.tracking));
    }

    loadInterestPoints(idUser: string) {
        this.overlaysInterestPoints.forEach(item => {
            item.setMap(null);
            item = null;
        });
        this.overlaysInterestPoints = [];

        if (!this.showInterestPoint) {
            return;
        }
        this.interestPointService.findPublic().then(data => {
            let response: any = data;
            if (response.interestPoints) {
                response.interestPoints.forEach(item => {
                    this.addMarkerInterestPoint(item);
                });
            }
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
        });

        this.interestPointService.findByUser(idUser).then(data => {
            let response: any = data;
            if (response.interestPoints) {
                response.interestPoints.forEach(item => {
                    this.addMarkerInterestPoint(item);
                });
            }
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
        });
    }

    loadPositions(idUser: String) {
        this.userService.devices = [];
        this.deviceService.findByUser(idUser).then(data => {

            //this.cleanOverlays()
            let response: any = data;
            response.devices.forEach(item => {
                if (item.positions && item.positions.length > 0) {
                    let lastConnection = this.userService.getLastConnection(item.positions[0].deviceTime);
                    if (lastConnection >= 2880) {
                        item.url = 'assets/layout/images/markers/cars/car' + item.icono + 'b.png';
                    } else if (lastConnection >= 30) {
                        item.url = 'assets/layout/images/markers/cars/car' + item.icono + 'r.png';
                    } else {
                        item.url = 'assets/layout/images/markers/cars/car' + item.icono + '.png';
                    }
                } else {
                    item.url = 'assets/layout/images/markers/cars/car' + item.icono + 'b.png';
                }

                this.userService.devices.push(item);
            });
            if (this.firstTime) {
                this.userService.deviceSelected = this.userService.devices[0];
            }
            this.userService.loadOverlays();
            this.onRowSelect(null);
            if (this.showMarkerCluster) {
                this.markerCluster = new MarkerClusterer(this.userService.map, this.userService.markers, {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
            }
            this.tracking = localStorage.getItem('tracking') == null ? true : JSON.parse((localStorage.getItem('tracking')));
            this.activateTracking(idUser);
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
        });
    }

    removeDuplicates(originalArray, prop) {
        return originalArray.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
        });
    }

    getContentInterestPoint(interestPoint: any) {
        let content = '<div id="iw-container">' +
            '<div class="iw-title" style="text-align:center;">' + interestPoint.name + '</div>' +
            '<div class="iw-content">' +
            '<div>';
        if (interestPoint.description != undefined) {
            content += '<label style="font-weight: bold;">Descripción: </label><label>' + interestPoint.description + '</label>';
        } else {
            content += '<label style="font-weight: bold;">Descripción: </label><label>Sin Descripción</label>';
        }
        content += '</div>' +
            '</div>' +
            '</div>';
        return content;
    }

    removeGeofences() {
        for (let i in this.labels) {
            this.labels[i].setMap(null);
        }
        this.labels = [];
        let newArray = [];
        for (let i in this.userService.overlays) {
            if (this.userService.overlays[i] instanceof google.maps.Polyline && this.userService.overlays[i].strokeColor == '#1976D2') {
                continue;
            } else {
                if (this.userService.overlays[i] instanceof google.maps.Circle || this.userService.overlays[i] instanceof google.maps.Polygon) {
                    continue;
                } else {
                    newArray.push(this.userService.overlays[i]);
                }
            }
        }
        this.userService.overlays = newArray;
    }

    onRowSelect(event) {
        if (this.userService.deviceSelected == undefined || this.userService.deviceSelected == null) {
            return;
        }

        this.userService.position = this.userService.deviceSelected.positions[0];
        if (this.userService.position) {
            this.userService.map.setCenter(new google.maps.LatLng(this.userService.position.latitude, this.userService.position.longitude));
            this.userService.map.setZoom(15);
            this.firstTime = false;
        }

        this.removeGeofences();
        if (this.showGeocercas) {
            this.geofenceService.findByDevice(this.userService.deviceSelected.idDevice).then(data => {
                let response: any = data;
                response.geofences.forEach(geofence => {
                    console.log(geofence);
                    if (geofence.type == 'C') {
                        let latlng = new google.maps.LatLng(geofence.circle.centerLatitude, geofence.circle.centerLongitude);

                        let circle = new google.maps.Circle({
                            center: latlng,
                            fillColor: '#1976D2',
                            fillOpacity: 0.35,
                            strokeWeight: 1,
                            radius: geofence.circle.radius
                        });
                        this.userService.overlays.push(circle);
                        /*let mapLabel = new MapLabel({
                            text: geofence.name,
                            position: latlng,
                            map: this.userService.map,
                            fontSize: 20,
                            align: 'center'
                        });
                        this.labels.push(mapLabel);*/
                    } else if (geofence.type == 'L') {
                        let line = new google.maps.Polyline({
                            geodesic: true,
                            strokeColor: '#1976D2',
                            strokeOpacity: 0.35,
                            strokeWeight: geofence.line.distance
                        });
                        let latlng = null;
                        geofence.line.coordinates.forEach(item => {
                            latlng = new google.maps.LatLng(item.latitude, item.longitude);
                            line.getPath().push(latlng);
                        });
                        this.userService.overlays.push(line);
                        /*let mapLabel = new MapLabel({
                            text: '   ' + geofence.name,
                            position: latlng,
                            map: this.userService.map,
                            fontSize: 20,
                            align: 'left'
                        });
                        this.labels.push(mapLabel);*/
                    } else if (geofence.type == 'P') {
                        let polygon = new google.maps.Polygon({
                            strokeColor: '#1976D2',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: '#1976D2',
                            fillOpacity: 0.35
                        });
                        let latlng = null;
                        geofence.polygon.coordinates.forEach(item => {
                            latlng = new google.maps.LatLng(item.latitude, item.longitude);
                            polygon.getPath().push(latlng);
                        });
                        this.userService.overlays.push(polygon);
                        /*let mapLabel = new MapLabel({
                            text: geofence.name,
                            position: latlng,
                            map: this.userService.map,
                            fontSize: 20,
                            align: 'center'
                        });
                        this.labels.push(mapLabel);*/
                    }
                });
            }).catch(err => {
                console.log(err);
                this.msgs = [{
                    severity: 'error',
                    summary: 'ERROR',
                    detail: 'Existe algun problema con la conexión al servidor'
                }];
            });
        }
    }


    loadDevices(idUser: string) {
        this.userService.overlays = [];
        this.firstTime = true;


        this.loadInterestPoints(idUser);

        //this.devices = [];
        //this.refreshLastPosition(idUser);
        this.loadPositions(idUser);
    }

    refreshDevices(event) {
        //this.cleanOverlays();
        this.loadDevices(event.value);
    }

    refresh(event) {
        this.showLegend = !this.showLegend;
    }

    showSendCommand(device: any) {
        this.command = {
            idUser: this.userService.userLoged.idUser,
            idDevice: device.idDevice,
            nameDevice: device.name,
            channel: 'GPRS',
            phone: device.phone
        };
        this.displaySendCommand = true;
    }

    hide() {
        this.displaySendCommand = false;
    }

    sendCommand() {
        this.blockedDocument = true;
        this.commandService.create(this.command).then(data => {
            const response: any = data;
            if (response.status === 'OK') {
                this.msgs = [{
                    severity: 'info',
                    summary: 'INFO',
                    detail: 'Envío de comando realizado satisfactoriamente'
                }];
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
            this.hide();
        }).catch(err => {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: err}];
            this.blockedDocument = false;
        });
    }

    isIgnition(position: any): boolean {
        let ignition = false;
        if (position.extended) {
            position.extended.forEach(element => {
                if (element.key == 'ignition') {
                    if (element.value == 'true') {
                        ignition = true;
                    }
                }
            });
        }
        return ignition;
    }

    showMonitoring(device: any) {
        let parameters = {idDevice: device.idDevice, idUser: this.userService.userLoged.idUser, phone: device.phone};
        window.open(window.location.href.replace('home', 'monitoring?token=' + btoa(JSON.stringify(parameters))), '_blank');
    }

    showSharing(device: any) {
        this.userService.deviceSelected = device;
        this.onRowSelect(device);
        if (device.positions && device.positions.length > 0) {
            let ultimaPosicion = device.positions[0];
            this.urlCurrentLocation = 'https://maps.google.com/?q=' + ultimaPosicion.latitude + ',' + ultimaPosicion.longitude;
            this.changeTime({value: 1});
            this.dialogShare = true;
        } else {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: 'El equipo no tiene posiciones guardadas'}];
        }
    }

    copyInputMessage(inputElement) {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
        this.msgs = [{severity: 'success', summary: 'EXITO', detail: 'Link copiado exitosamente'}];
    }

    generateURL() {
        this.changeTime({value: this.time});
        let parameters = {
            idDevice: this.userService.deviceSelected.idDevice,
            idUser: this.idUser,
            startDate: this.startDate.toISOString(),
            endDate: this.endDate.toISOString()
        };
        this.urlRealTimeLocation = environment.monitoringURL + btoa(JSON.stringify(parameters));
    }

    changeTime(event: any) {
        this.time = event.value;
        let dateTime = new Date();
        this.startDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), dateTime.getHours(), dateTime.getMinutes(), dateTime.getSeconds()));
        this.endDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), dateTime.getHours(), dateTime.getMinutes(), dateTime.getSeconds()));
        if (event.value == 1) {
            this.endDate.setHours(this.endDate.getHours() + 1);
        } else if (event.value == 3) {
            this.endDate.setHours(this.endDate.getHours() + 3);
        } else if (event.value == 6) {
            this.endDate.setHours(this.endDate.getHours() + 6);
        } else if (event.value == 12) {
            this.endDate.setHours(this.endDate.getHours() + 12);
        } else if (event.value == 24) {
            this.endDate.setHours(this.endDate.getHours() + 24);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts